import gql from "graphql-tag";
import { CANVAS_MESSAGE_FIELDS } from "../queries/processes";

export const CREATE_PROCESS = gql`
  mutation AddProcess($data: ProcessDataInput) {
    addProcess(data: $data) {
      id
    }
  }
`;

export const UPDATE_PROCESS = gql`
  mutation UpdateProcess($where: ProcessWhereInput, $data: ProcessDataInput) {
    updateProcess(where: $where, data: $data) {
      id
    }
  }
`;

export const DELETE_PROCESS = gql`
  mutation DeleteProcess($where: ProcessWhereInput) {
    deleteProcess(where: $where) {
      id
    }
  }
`;

export const DUPLICATE_PROCESS = gql`
  mutation duplicateProcess(
    $where: ProcessWhereInput
    $data: ProcessDataInput
  ) {
    duplicateProcess(where: $where, data: $data) {
      id
    }
  }
`;

export const UPDATE_PROCESS_STATUS_FORM_DEFINITION = gql`
  mutation UpdateProcessStatusFormDefinition(
    $where: ProcessStatusWhereInput!
    $formDefinition: JSONObject
  ) {
    updateProcessStatusFormDefinition(
      where: $where
      formDefinition: $formDefinition
    ) {
      id
      formDefinition
    }
  }
`;

export const GENERATE_PROCESS_GUEST_LINK = gql`
  mutation GenerateProcessGuestLink(
    $where: ProcessWhereInput!
    $baseUrl: String!
  ) {
    generateProcessGuestLink(where: $where, baseUrl: $baseUrl) {
      id
      name
      platform
      status
      guestLink(baseUrl: $baseUrl)
    }
  }
`;

export const SAVE_PROCESS_DRAFT = gql`
  mutation SaveProcessDraft(
    $where: ProcessDraftWhereInput!
    $data: ProcessDraftDataInput!
  ) {
    saveProcessDraft(where: $where, data: $data) {
      id
      revision
      updatedDate
      updatedBy
    }
  }
`;

export const DISCARD_PROCESS_DRAFT = gql`
  mutation DiscardProcessDraft($where: ProcessDraftWhereInput!) {
    discardProcessDraft(where: $where)
  }
`;

export const PUBLISH_CANVAS = gql`
  mutation PublishCanvas(
    $where: ProcessDraftWhereInput!
    $data: PublishCanvasDataInput
  ) {
    publishCanvas(where: $where, data: $data) {
      published
      blockedSteps {
        id
        name
        clients
      }
      incompleteScreens {
        screenId
        versionId
        stepId
        stepName
      }
      publishedScreens
      removedSteps
    }
  }
`;

export const NEW_CANVAS_CONVERSATION = gql`
  mutation NewCanvasConversation($where: ProcessDraftWhereInput!) {
    newCanvasConversation(where: $where) {
      id
      createdDate
      messages {
        ${CANVAS_MESSAGE_FIELDS}
      }
    }
  }
`;

export const SEND_CANVAS_MESSAGE = gql`
  mutation SendCanvasMessage(
    $where: ProcessDraftWhereInput!
    $data: CanvasMessageDataInput!
  ) {
    sendCanvasMessage(where: $where, data: $data) {
      ${CANVAS_MESSAGE_FIELDS}
    }
  }
`;

export const APPLY_CANVAS_PROPOSAL = gql`
  mutation ApplyCanvasProposal($where: CanvasMessageWhereInput!) {
    applyCanvasProposal(where: $where) {
      applied
      revision
      errors
    }
  }
`;

export const REFUSE_CANVAS_PROPOSAL = gql`
  mutation RefuseCanvasProposal($where: CanvasMessageWhereInput!) {
    refuseCanvasProposal(where: $where) {
      ${CANVAS_MESSAGE_FIELDS}
    }
  }
`;

const processes = {
  CREATE_PROCESS,
  UPDATE_PROCESS,
  DELETE_PROCESS,
  DUPLICATE_PROCESS,
  UPDATE_PROCESS_STATUS_FORM_DEFINITION,
  GENERATE_PROCESS_GUEST_LINK,
  SAVE_PROCESS_DRAFT,
  DISCARD_PROCESS_DRAFT,
  PUBLISH_CANVAS,
  NEW_CANVAS_CONVERSATION,
  SEND_CANVAS_MESSAGE,
  APPLY_CANVAS_PROPOSAL,
  REFUSE_CANVAS_PROPOSAL,
};

export default processes;
